<template>
  <div class="stock-wrap" v-if="stockList.length>0">
    <div class="title sepBottom S8 T1 bold">相关股票</div>
    <div
      class="content"
      v-for="(item, index) in stockList"
      :key="index"
      :class="index!==stockList.length-1?'sepBottom':''"
      @click="gotoStocks(item.stockId)"
    >
      <div class="first">
        <div class="name S8 T1">{{ item.name }}</div>
        <div class="code S4 T3 digitFont">{{ handleCode(item.stockId) }}</div>
      </div>
      <div
        class="second S10 T1 digitFont"
      >{{ conversion(stockMSG[index] ? stockMSG[index].Value : 0) }}</div>
      <div
        class="third S10 digitFont"
        :class="[conversion(stockMSG[index] ? stockMSG[index].extends[1] : 0, 1) >0?'C1':'C3']"
      >{{ conversion(stockMSG[index] ? stockMSG[index].extends[1] : 0, 1) }}%</div>
      <!-- <template v-if="list.length"> -->
      <div class="four S5 T3 aly" v-if="list.includes(item.stockId)">已添加</div>
      <div class="four S5 C5" v-else @click.stop="addZxg(item.stockId)">+自选</div>
      <!-- </template> -->
    </div>
  </div>
</template>
<script>
import ym from '@/assets/js/ym'
import axios from 'axios'

export default {
  components: {},
  props: {
    stockList: Array,
    stockListCode: Array,
  },
  data() {
    return {
      stockMSG: [],
      list: [],
    }
  },
  computed: {},
  watch: {
    stockListCode: {
      handler: function (val) {
        this.getStockPrice()
        this.queryStock(val)
      },
      deep: true,
      immediate: true,
    },
  },
  created() {},
  methods: {
    // 处理股票code长度
    handleCode(code) {
      code = '' + code
      if (code.length === 7) {
        code = code.slice(1)
      }
      return code
    },
    // 跳转个股详情
    gotoStocks(stockid) {
      ym.openstock(stockid)
    },
    // 添加/删除自选股
    addZxg(stockId) {
      ym.controlZxg({
        goodsIds: [stockId],
        type: 1,
        onSuccess: () => {
          this.list.push(stockId)
          this.$toast('自选股添加成功')
        },
        onFail: () => {
          this.$toast('自选股添加失败')
        },
      })
    },
    gotoStock() {
      ym.openstock(this.stockId)
    },
    // 查询是否在自选股
    queryStock(stockIds) {
      ym.isGoodsAddedZxg({
        goodsIds: stockIds,
        callback: (list) => {
          this.list = list
        },
      })
    },
    // 股票实时股价
    async getStockPrice() {
      let requestData = {
        custom: {
          goodsId: this.stockListCode,
        },
        fieldsId: [0, 1, 6, 84, 85],
        limitSize: this.stockListCode.length,
      }
      let { data } = await axios({
        url: `https://emapp.emoney.cn/transfer/bs.m.emoney.cn?X-Protocol-Id=2100`,
        method: 'post',
        dataType: 'json',
        headers: {
          'Content-Type': 'text/plain',
        },
        data: requestData,
      })
      console.log(data)
      if (data && data.detail) {
        let detail = data.detail

        if (detail) {
          let valueList = detail.valueList

          if (valueList && valueList.length > 0) {
            let resultList = this.getValue(valueList)
            this.stockMSG = resultList
          }
        }
      }
    },
    getValue(list, fieldsRule) {
      if (list && list.length > 0) {
        let resultArray = []

        list.forEach(function (element) {
          let fieldValue = element.fieldValue
          let percentValue = parseInt(fieldValue[2])
          percentValue = isNaN(percentValue) ? 0 : percentValue
          let others = []
          let extendsObj = {}
          if (fieldValue.length > 3) {
            for (var index = 3; index < fieldValue.length; index++) {
              if (
                fieldsRule &&
                fieldsRule.length &&
                fieldValue.length - 3 === fieldsRule.length
              ) {
                extendsObj[fieldsRule[index - 3]] = fieldValue[index]
              } else {
                others.push(fieldValue[index])
              }
            }
          }

          resultArray.push({
            Name: fieldValue[0],
            Code: element.goodsId,
            Value: percentValue,
            ...extendsObj,
            extends: others,
          })
        }, this)

        return resultArray
      }
    },
    conversion(data, type) {
      var divisor = type ? 100 : 10000
      return (parseFloat(data) / divisor).toFixed(2)
    },
  },
}
</script>
<style lang="scss" scoped>
.stock-wrap {
  .content {
    margin: 0 30px;
    padding: 30px 0;
    display: flex;
    justify-content: space-between;
    align-items: center;

    > div {
      flex: 2;

      &:first-child {
        flex: 3;
      }

      &:last-child {
        flex: none;
      }
    }

    .code {
      margin-top: 2px;
    }

    .four {
      display: flex;
      justify-content: center;
      align-items: center;
      width: 118px;
      height: 52px;
      border-radius: 5px;
      border: 2px solid #046bcc;
    }
    .aly {
      border: 2px solid #858585 !important;
    }
  }

  .title {
    padding: 38px 0 38px 30px;
  }

  .bold {
    font-weight: 700;
  }
}
</style>
